import { MEDIUM_BREAKPOINT } from '../../components/modular-grid/constants';
import { DeviceOs, DeviceOsValues } from '../../logic/main/types';

export interface HideOnConditionProps {
  width?: number;
  deviceOs?: DeviceOs;
}

export const byHideOnPredicate = (
  hideOnConditionProps: HideOnConditionProps = {}
) => (item: { hide_on?: string[] }) => {
  const filterPredicate = getFilterPredicateMap(hideOnConditionProps);
  return !item.hide_on || item.hide_on.every(filterPredicate);
};

const getFilterPredicateMap = (hideOnConditionProps: HideOnConditionProps) => (
  filter: string
) => {
  const predicateMap = {
    large: largeScreenFilter,
    small: smallScreenFilter,
    not_windows: notWindowsOsFilter,
    not_ios: notiOSFilter,
    not_android: notAndroidFilter,
    not_osx: notOSXFilter,
    not_linux: notLinuxFilter,
  };
  const predicate =
    predicateMap[filter.toLowerCase() as keyof typeof predicateMap] ||
    (() => true);
  return predicate(hideOnConditionProps);
};

const largeScreenFilter = ({ width }: HideOnConditionProps) => {
  if (!width) {
    return true;
  }
  return width < MEDIUM_BREAKPOINT.max;
};

const smallScreenFilter = ({ width }: HideOnConditionProps) => {
  if (!width) {
    return true;
  }
  return width >= MEDIUM_BREAKPOINT.max;
};

const notWindowsOsFilter = ({ deviceOs }: HideOnConditionProps) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.Windows;
};

const notiOSFilter = ({ deviceOs }: HideOnConditionProps) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.IOS;
};

const notAndroidFilter = ({ deviceOs }: HideOnConditionProps) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.Android;
};

const notOSXFilter = ({ deviceOs }: HideOnConditionProps) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.OSX;
};

const notLinuxFilter = ({ deviceOs }: HideOnConditionProps) => {
  if (!deviceOs) {
    return true;
  }
  return deviceOs === DeviceOsValues.Linux;
};
